module.exports = __webpack_public_path__ + "img/h-page4-35.50a4e27c.png";